import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _unionBy from 'lodash/unionBy';
import { 
  getReferralAnalyses, 
  getReferralAnalysis,
  clearLocalReferralAnalyses,
  clearLocalActiveReferralAnalysis 
} from "./actions";

export const initialState = {
  all: { 
    data: [], 
    pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } 
  },
  referralAnalysis: { 
    id: '', 
    result: '', 
    status: '', 
    updated_at: '' 
  },
  loading: { 
    all: false, 
    referralAnalysis: false 
  }
};

const slice = createSlice({
  name: 'referralAnalyses',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getReferralAnalyses.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getReferralAnalyses.fulfilled, (state, action) => {
        const { referral_analyses, pagination } = action.payload;
        const newData = _unionBy([...state.all.data, ...referral_analyses], 'id');
        
        state.loading.all = false;
        state.all.data = newData;
        state.all.pagination = pagination;
      })
      .addCase(getReferralAnalyses.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getReferralAnalysis.pending, (state) => {
        state.loading.referralAnalysis = true;
      })
      .addCase(getReferralAnalysis.fulfilled, (state, action) => {
        const { data: { referral_analysis }, cable } = action.payload;
        const foundedReferralAnalysis = !!_find(state.all.data, (s) => s.id === referral_analysis.id);
        const updatedReferralAnalysis = { ...state.referralAnalysis, ...referral_analysis };
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = foundedReferralAnalysis ? _map(state.all.data, (e) => e.id === referral_analysis.id ? { ...e, ...referral_analysis } : e) : [...[referral_analysis], ...oldAllData]; 
        const pagination = foundedReferralAnalysis ? state.all.pagination : { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.referralAnalysis = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        if (foundedReferralAnalysis && !cable) state.referralAnalysis = updatedReferralAnalysis;       
      })
      .addCase(getReferralAnalysis.rejected, (state) => {
        state.loading.referralAnalysis = false;
      })
      .addCase(clearLocalReferralAnalyses, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActiveReferralAnalysis, state => {
        state.referralAnalysis = initialState.referralAnalysis;
      })
  }
})

export default slice.reducer;